<template>
  <b-img :src="src" width="16" height="16" class="mr-2 site_favicon" />
</template>
<script>

export default {
  name: 'Favicon',
  props: ['url'],
  computed: {
    src: function() {
      let domain = this.url
      try {
        domain = new URL(this.url).hostname
      } catch(e) {}
      return `https://siteseer.io/favicons?domain=${domain}`
    },
  },
}
</script>
